const project = {
  slug: "terralanka-land-marketplace",
  title: "Terralanka - Real Estate Platform for Sri Lanka",
  oneLiner: "Buy and sell land and rent villas across Sri Lanka on a single real estate marketplace.",
  role: ["Full-stack Developer"],
  category: "Web Development",
  clientOrOrg: "Terralanka",
  timeframe: { start: "2025", status: "Shipped" },
  domain: ["PropTech", "Real Estate", "Marketplace"],
  tech: ["PHP", "MySQL", "JavaScript"],
  links: { live: "https://terralanka.com" },
  gallery: [
    {
      src: "/assets/terralanka/terralanka-1.png",
      alt: "Terralanka home page showcasing land listings and villa rentals across Sri Lanka"
    },
    {
      src: "/assets/terralanka/terralanka-2.png",
      alt: "Terralanka services overview page"
    },
    {
      src: "/assets/terralanka/terralanka-lifecycle.png",
      alt: "Terralanka end-to-end land buying and renting lifecycle"
    },
  ],
  impact: [
    "Launched a real estate platform for Sri Lanka where visitors can buy and sell land and rent villas in one place.",
    "Connected buyers, sellers, and renters across the island through a single browseable marketplace."
  ],
  responsibilities: [
    "Built the land buy/sell listings and villa rental catalog with browse and detail views.",
    "Implemented seller listing submission and buyer/renter enquiry flows.",
    "Developed the admin tooling used to manage listings, rentals, and enquiries."
  ],
  features: [
    "Browse and search land for sale across Sri Lanka",
    "List your own land for sale",
    "Browse and book villa rentals",
    "Buyer and renter enquiry forms",
    "Admin dashboard for managing listings and rentals"
  ],
  architecture: [
    "Pure PHP backend with MySQL for listings, rentals, and enquiries",
    "Server-rendered pages with vanilla JavaScript for interactive UI",
    "Admin moderation workflow for publishing listings and rental properties"
  ],
  seo: {
    title: "Terralanka - Buy/Sell Land & Rent Villas in Sri Lanka",
    description:
      "Built a Sri Lankan real estate platform for buying and selling land and renting villas using PHP, MySQL, and JavaScript."
  },
  cover: "/assets/terralanka/terralanka-featured.png"
};

export default project;
